import React from 'react';
import { useSelector } from 'react-redux';
import { ShowMoreItemWrapper, CenterWrapper } from './ShowMoreItem.style';

const ShowMoreItem = ({ showMore, ...rest }) => {
    const moreAvailable = useSelector(state => state.contract.moreAvailable);

    const searchingInProgress = useSelector(state => state.contract.searchingInProgress);

    const totalSearchResults = useSelector(state => state.contract.totalSearchResults);

    const searchResultsPageSize = useSelector(state => state.contract.searchResultsPageSize);

    const noResults = totalSearchResults === 0;

    return (
        <ShowMoreItemWrapper id="show_more" onClick={showMore} {...rest}>
            {moreAvailable ? (
                searchingInProgress ? (
                    <CenterWrapper data-testid="loading">Searching ...</CenterWrapper>
                ) : noResults ? (
                    <CenterWrapper data-testid="no-results">No results</CenterWrapper>
                ) : (
                    <CenterWrapper data-testid="fetch-more">{`SHOW ${searchResultsPageSize} MORE`}</CenterWrapper>
                )
            ) : noResults ? (
                <CenterWrapper data-testid="no-items">No results</CenterWrapper>
            ) : (
                <CenterWrapper data-testid="no-more-results">No more results</CenterWrapper>
            )}
        </ShowMoreItemWrapper>
    );
};

export default ShowMoreItem;
